var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('img',{attrs:{"src":_vm.png1}})])
}
var staticRenderFns = []

export { render, staticRenderFns }